import script from "./goals.vue?vue&type=script&setup=true&lang=js"
export * from "./goals.vue?vue&type=script&setup=true&lang=js"

import "./goals.vue?vue&type=style&index=0&id=33afca1a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33afca1a"]])

export default __exports__